import React from "react";
import ctl from "@netlify/classnames-template-literals";

import { Ntext } from "components";

const HowItWorksCard = ({ instruction, graphic }) => {
  return (
    <article className={cardStyle}>
      <Ntext
        color="n-yellow2"
        value={instruction}
        className="!font-medium !-tracking-[0.8px] text-center !min-w-[208px]"
        variant="h6"
      />
      {graphic}
    </article>
  );
};

const cardStyle = ctl(`
  flex
  flex-col
  space-y-8
  lg:h-[348px]
  max-w-[312px]
  overflow-clip
  items-center
  rounded-3xl
  bg-n-grey8
  h-[340px]
  px-16
  pt-8
`);

export { HowItWorksCard };
